<ng-template #statusModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title" id="Status-Modal">Cập nhật trạng thái</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <div class="mb-3">
            <label class="form-label">Chọn trạng thái mới cho bài viết: <strong>{{ data?.postTitle }}</strong></label>
            <div class="d-flex justify-content-center gap-5 mt-3">
                <div *ngFor="let s of statuses" class="form-check">
                    <input class="form-check-input" type="radio" [id]="'status' + s.value" [value]="s.value" [(ngModel)]="status" name="postStatus">
                    <label class="form-check-label badge {{ s.class }} ms-1" [for]="'status' + s.value">
                        {{ s.label }}
                    </label>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss('Close click')">{{ 'cancel' | translate }}</button>
        <button type="button" class="btn btn-theme" (click)="confirm()">{{ 'confirm' | translate }}</button>
    </div>
</ng-template>
